import React, {useEffect, useMemo, useState} from 'react';

import {useStore} from 'effector-react';
import debounce from 'lodash/debounce';
import {useTranslation} from 'react-i18next';

import {ReactComponent as ClearIcon} from 'assets/svg/cross.svg';
import {Input} from 'components/ui-kit/Input';
import {search$, searchChanged} from 'models/codeLocks';

import {CancelIcon} from '../../../MovingGrid/Table/search/styled';

export const TableSearch = () => {
    const {t} = useTranslation();
    const search = useStore(search$);
    const [value, setValue] = useState(search);

    useEffect(() => setValue(search), [search]);

    const updateSearch = useMemo(
        () =>
            debounce((nextValue: string, previousValue: string) => {
                if (nextValue !== previousValue) searchChanged(nextValue);
            }, 1000),
        [],
    );

    useEffect(() => {
        updateSearch(value, search);
        return updateSearch.cancel;
    }, [search, updateSearch, value]);

    return (
        <Input
            value={value}
            size="sm"
            onChange={(event) => setValue(event.target.value)}
            placeholder={t('pages.documents.blocking.search')}
            style={{minWidth: 350}}
            adornment={
                <CancelIcon
                    width={10}
                    height={10}
                    source={ClearIcon}
                    onClick={() => setValue('')}
                />
            }
        />
    );
};
